import { useQuery } from '@tanstack/react-query';
import { getProjects } from '../../api/apiProjects';

export const useGetProjects = (params = {}) => {
    return useQuery({
        queryKey: ['projects', params],
        queryFn: () => getProjects(params),
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};